import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'specializationsFilter', namespaced: true })
export default class SpecializationsFilter extends FilterModule {
    constructor(module: SpecializationsFilter) {
        super(module);
    }
}
